import { createTheme, responsiveFontSizes } from "@mui/material";
import { grey } from "@mui/material/colors";

const globalBorderRadius = 20;

let theme = createTheme({
  direction: "rtl",
  palette: {
    mode: "dark",
    primary: {
      main: "#e0e0e0",
    },
    secondary: {
      main: "#e0e0e0",
    },
    text: {
      primary: "#fff",
      secondary: "#bdbdbd",
    },
    background: { default: "#141414", paper: "#141414" },
  },
  typography: {
    fontFamily: "mitra",
    fontSize: 13,
  },
  shadows: Array(25).fill("none"),
  shape: {
    borderRadius: globalBorderRadius,
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#141414",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {},
        rounded: {
          borderRadius: globalBorderRadius,
        },
        elevation1: {
          boxShadow: "none",
          border: "1px solid #ffffff11",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: globalBorderRadius,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label.Mui-focused": {},
          "& .MuiInput-underline:after": {
            borderColor: grey[900],
          },
          "& .MuiOutlinedInput-root": {
            backgroundColor: grey[900],
            borderRadius: globalBorderRadius,
            "& fieldset": {
              borderColor: grey[900],
            },
            "&:hover fieldset": {
              borderColor: grey[900],
            },
            "&.Mui-focused fieldset": {
              borderColor: grey[900],
            },
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: globalBorderRadius,
          marginBottom: 5,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
          },
        },
        textPrimary: { color: grey["600"] },
        root: {
          borderRadius: globalBorderRadius,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paperAnchorDockedLeft: {
          borderRight: "none !important",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: 145,
          minWidth: 145,
          border: 0,
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
